import { FC, useEffect, useState } from "react";
import { Calendar } from "../../../../shared/ui/calendar";
import classes from './studentCalendar.module.scss'
import { IStudentFinance, studentService } from "../../../../entities/student";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import { useMyActions } from "../../../../entities/my";
import { useGlobalMessageActions } from "../../../../entities/globalMessage";
import { MyError } from "../../../../shared/lib/error/MyError";
import { AuthError } from "../../../../shared/lib/error/AuthError";
import { OpenContainer } from "../../../../features/openContainer";
import { getDateUTC } from "../../../../shared/lib/helpers/getDateUTC";

interface IProps {
    id: number;
}

export const StudentCalendar: FC<IProps> = ({id}) => {

    const [finance, setFinance] = useState<IStudentFinance | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [trigger, setTrigger] = useState<number>(0)

    const {setIsAuth} = useMyActions()
    const {setGlobalMessage} = useGlobalMessageActions()

    const getData = async (startDate: string, endDate: string) => {
        try{
            setIsLoading(true)
            const financeRes = await studentService.getFinance(id, startDate, endDate)
            setFinance(financeRes)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при получении финансов студента', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    const setDate = (startDate: Date | null, endDate: Date | null) => {
        if(startDate && endDate){
            getData(getDateUTC(startDate), getDateUTC(endDate))
        }
        if(!startDate && !endDate){
            setFinance(null)
        }
    }

    useEffect(() => {
        setTrigger(prev => prev + 1)
    }, [isLoading, finance])

    return (
         <section className={classes.container}>
            <OpenContainer
                title="Финансы"
                trigger={trigger}
                icon={<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M3 10H21M16 14H18" /></svg>}
            >
                <section className={classes.content}>
                    <Calendar 
                        onDateRangeSelect={setDate} 
                        isLoading={isLoading}
                    />
                    {
                        isLoading
                            ?
                        <section className={classes.loader}><LoaderSpinner /></section>
                            :
                        finance
                            &&
                        <section className={classes.data}>
                            <span>Количество занятий: {finance?.count}</span>
                            <span>Количество часов: {finance?.hours || '0'}</span>
                            <span>Прибыль: {finance?.amount} ₽</span>
                            {
                                finance?.total_confirmed_amount != null
                                    &&
                                <span>Сумма подтверждённых транзакций: {finance.total_confirmed_amount} ₽</span>
                            }
                        </section>
                    }
                </section>
            </OpenContainer>
        </section>
    )
}
